<template>
  <AuthView title="Coupons">
    <AppRow>
      <table>
        <thead>
          <tr>
            <th>Code</th>
            <th>Discount</th>
            <th>Activations</th>
            <th>Orders</th>
            <th>Partner</th>
            <th>Expiry</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="coupon in coupons">
            <td>
              <pre>{{ coupon.code }}</pre>
            </td>
            <td>
              {{ coupon.discount }}%
            </td>
            <td>
              {{ coupon.activation_count }}
            </td>
            <td>
              {{ coupon.order_count }}
            </td>
            <td>
              {{ coupon.partner?.name || '' }}
              <br>
              {{ coupon.partner?.email || '' }}
            </td>
            <td style="white-space: nowrap;">
              <component v-if="coupon.expiry" :is="isPast(coupon.expiry) ? 's' : 'span'">
                {{ coupon.expiry }}
              </component>
            </td>
            <td>
              <AppBtn @click="del(coupon.code)">
                <TrashIcon />
              </AppBtn>
            </td>
          </tr>
        </tbody>
      </table>
      <LightBox>
        <CreateCouponForm @added="fetchCoupons" />
      </LightBox>
    </AppRow>
  </AuthView>
</template>

<script setup lang="ts">
import { isPast } from '~/helpers/date';
import { deleteCoupon, getCoupons } from '~/helpers/http';
import type { Coupon } from '~/types';

definePageMeta({ middleware: 'admin' });

const coupons = ref<Coupon[]>(await getCoupons());

async function fetchCoupons() {
  coupons.value = await getCoupons();
}

async function del(code: Coupon['code']) {
  const response = await deleteCoupon(code);
  if (response?.success) {
    coupons.value = coupons.value.filter(coupon => coupon.code != code);
  }
}
</script>